import { com } from '@eidu/form'
import entityApiUrl from '../entity/baseUrl'
import AuthenticationContext from '../authorization/AuthenticationContext'
import HttpError from '../HttpError'
import SemanticLink = com.eidu.sharedlib.entity.analytics.SemanticLink
import SemanticLinksResponse = com.eidu.sharedlib.entity.analytics.SemanticLinksResponse

type GetSemanticLinksParameters = { authContext: AuthenticationContext }

const getSemanticLinks = ({ authContext }: GetSemanticLinksParameters): Promise<readonly SemanticLink[]> =>
  fetch(`${entityApiUrl}/organizations/${authContext.organizationId}/semantic-links`, {
    headers: { Authorization: `Bearer ${authContext.accessToken}` },
  }).then(async (response) => {
    switch (response.status) {
      case 200:
        return SemanticLinksResponse.fromJsonString(await response.text()).semanticLinks.asJsReadonlyArrayView()
      case 403:
        throw new HttpError(403, 'Forbidden')
      default:
        throw new HttpError(
          response.status,
          `Unexpected response code ${response.status} from getSemanticLinks endpoint`
        )
    }
  })

export default getSemanticLinks
